import PagedRequest, { PagedResponse } from "../requests";

export interface OrderListItemResource {
  number: string;
  headerNumber: number;
  truckName: string;
  crn: string;
  po?: string;
  consignee: OrderParty;
  billTo: OrderParty;
  shipper: OrderParty;
  cabinetCount: number;
  unitCount: number;
  cubes: number | null;
  weight?: number | null;
  shipDate: Date | null;
  anticipatedReceiveDate: Date | null;
  actualReceiveDate: Date | null;
  requestedDeliveryDate: Date | null;
  scheduledDeliveryDate: Date | null;
  actualDeliveryDate: Date | null;
  timeframe: string;
  facility: string;
  remarks: string;
  specialRequests: string;
  manufacturer: string;
  deliveryType: string;
  status: string;
  miles: number | null;
  bookedBy: string;
  carrier: string;
  received: boolean;
  hasNotes: boolean;
  deliveryForId: number | null;
}

export interface OrderParty {
  name: string;
  id: string;
  address: Address;
  emailAddress: string;
  phoneType: string;
  phoneNumber: string;
  primaryPhone: string;
  secondaryPhone: string;
  location: any;
  standardizedAddress: Address;
  agentId: string;
  displayId: string;
}

export interface Address {
  streetLine1: string;
  streetLine2: string;
  city: string;
  state: string;
  zip: string;
}

export interface OrderField {
  key: string;
  label: string;
  sortable: boolean;
  formatter?: CallableFunction;
  hidden: boolean;
  requiresPermission?: string;
  sort?: number;
  disableMoving?: boolean;
  showInTooltip?: boolean;
  width?: string;
  padding?: string;
}

export interface OrderResource {
  number: string;
  trackingNumber: string | null;
  trackingNumberUrl: string | null;
  headerNumber: number;
  truckName: string;
  crn: string;
  po?: string;
  consignee: OrderParty;
  billTo: OrderParty;
  shipper: OrderParty;
  orderBy: OrderParty;
  cabinetCount: number;
  unitCount: number;
  cubes: number | null;
  shipDate: Date | null;
  anticipatedReceiveDate: Date | null;
  actualReceiveDate: Date | null;
  requestedDeliveryDate: Date | null;
  scheduledDeliveryDate: Date | null;
  actualDeliveryDate: Date | null;
  datePlaced: Date | null;
  timeframeStart: Date | null;
  timeframeEnd: Date | null;
  followUpDate: Date | null;
  dockSearchDate: Date | null;
  facility: string;
  remarks: string;
  specialRequests: string;
  manufacturer: string;
  deliveryType: string;
  status: string;
  miles: number;
  bookedBy: string;
  carrier: string;
  received: boolean;
  intermediateConsignee: string;
  codPending: boolean;
  customerNotReady: boolean;
  orderType: string;
  driverNote: string;
  rateBy: string;
  isScheduled: boolean;
  contactCompanyId: string;
  hasNotes: boolean | null;
  hasShipsWithOrders: boolean | null;
  loadDate: Date | null;
  truckId: number | string | null;
  barcodeOrderId: number | null;
  hasShipmentNotice: boolean;
  inventoryLinkable: boolean;
}

export class GetOrdersRequest extends PagedRequest {
  orderNumber?: number;
  crn?: string;
  zipZip3s?: string[];
  facilityCodes: string[];
  deliveryDate?: Date;
  deliveryTypes: string[];
  billTos: string[];
  manufacturers: string[];
  consigneeName: string;
  consigneeAddress: string;
  consigneePhone: string;
  hideManifestedOrders?: boolean;
  shipsWithOrderNumber: number;
  useTruckZipsTruckId?: number;
  excludeZipZip3s?: string[];
  excludeWillCall?: boolean;
}

export interface GetOrdersResponse extends PagedResponse<OrderListItemResource> {}
